import {useCallback, useState} from 'react'
import {checkExceptionDictionaryQueueName, prepareQueueName} from '../utils/helpers.js'

export const useEndpointsQueues = ({isSeparateName = false, QueueAlias = {}}) => {
    const [localEndpoints, setLocalEndpoints] = useState(null)

    const setEndpoints = useCallback((endpoints) => {
        if (isSeparateName) {
            const formattedEndpoints = endpoints.map(item => {
                // switch from id to name if using ids
                const endpointName = QueueAlias[prepareQueueName(item.name)] || item.name

                if (checkExceptionDictionaryQueueName(endpointName) || !endpointName.includes('-')) {
                    return {...item, name: endpointName}
                }
                return {...item, name: prepareQueueName(endpointName)}
            })

            setLocalEndpoints(formattedEndpoints)
        } else {
            setLocalEndpoints(endpoints)
        }

    }, [isSeparateName])

    return [localEndpoints, setEndpoints]
}
